import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { useId } from 'react';
import { Controller, type ControllerProps, type FieldValues, type Path, useFormContext } from 'react-hook-form';
import TemplateInput, { type TemplateInputProps } from '../../template-input';
import type { LabelTooltipProps } from '../internals/form-label';
import FormWrapper from '../internals/form-wrapper';
export type FormTemplateInputProps<TFieldValues extends FieldValues> = {
  name: Path<TFieldValues>;
  label?: string | React.ReactNode;
  rules?: ControllerProps<TFieldValues>['rules'];
  hint?: string | React.ReactNode;
  tooltip?: LabelTooltipProps;
  className?: string;
  errorPosition?: 'absolute' | 'relative';
  orientation?: 'vertical' | 'horizontal';
  addon?: React.ReactNode;
} & Omit<TemplateInputProps, 'value' | 'onBlur' | 'ref' | 'id'>;
export default function FormTemplateInput(t0) {
  const $ = _c(26);
  let addon;
  let hint;
  let inputProps;
  let label;
  let name;
  let rules;
  let t1;
  let t2;
  let t3;
  let tooltip;
  if ($[0] !== t0) {
    ({
      name,
      label,
      rules,
      hint,
      tooltip,
      size: t1,
      errorPosition: t2,
      orientation: t3,
      addon,
      ...inputProps
    } = t0);
    $[0] = t0;
    $[1] = addon;
    $[2] = hint;
    $[3] = inputProps;
    $[4] = label;
    $[5] = name;
    $[6] = rules;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = tooltip;
  } else {
    addon = $[1];
    hint = $[2];
    inputProps = $[3];
    label = $[4];
    name = $[5];
    rules = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    tooltip = $[10];
  }
  const size = t1 === undefined ? "default" : t1;
  const errorPosition = t2 === undefined ? "relative" : t2;
  const orientation = t3 === undefined ? "vertical" : t3;
  const {
    control
  } = useFormContext();
  const contextId = useId();
  let t4;
  if ($[11] !== addon || $[12] !== contextId || $[13] !== errorPosition || $[14] !== hint || $[15] !== inputProps || $[16] !== label || $[17] !== orientation || $[18] !== size || $[19] !== tooltip) {
    t4 = t5 => {
      const {
        field,
        fieldState
      } = t5;
      const error = fieldState.error?.message;
      return <FormWrapper id={contextId} error={error} label={label} errorPosition={errorPosition} size={size} hint={hint} tooltip={tooltip} orientation={orientation} fullWidth={true} disabled={inputProps.disabled || field.disabled} addon={addon}><TemplateInput {...inputProps} {...field} id={contextId} onChange={e => {
          field.onChange(e);
          inputProps.onChange?.(e);
        }} size={size} disabled={field.disabled || inputProps.disabled} data-dd-privacy="mask" hasError={!!error} className={cx({
          "rounded-bl-none! rounded-tl-none!": addon
        }, inputProps.className)} /></FormWrapper>;
    };
    $[11] = addon;
    $[12] = contextId;
    $[13] = errorPosition;
    $[14] = hint;
    $[15] = inputProps;
    $[16] = label;
    $[17] = orientation;
    $[18] = size;
    $[19] = tooltip;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== control || $[22] !== name || $[23] !== rules || $[24] !== t4) {
    t5 = <Controller name={name} control={control} rules={rules} render={t4} />;
    $[21] = control;
    $[22] = name;
    $[23] = rules;
    $[24] = t4;
    $[25] = t5;
  } else {
    t5 = $[25];
  }
  return t5;
}